export default __webpack_public_path__ + "static/media/logo-mock-exam.736dba6e.png";